module.exports = __webpack_public_path__ + "static/media/ImgENG.fd286f4b.svg";